
const digest = '1548d3ce07de5d47592e2e8370e1c2fc95edc544b925694da47e44a96c80ed68';
const classes = {"wrapper":"_wrapper_1n1l6_1","content":"_content_1n1l6_8","controls":"_controls_1n1l6_17"};
const css = `._wrapper_1n1l6_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-height: 0;
}
._wrapper_1n1l6_1 ._content_1n1l6_8 {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 0;
  overflow: hidden;
  padding: 20px;
}
._wrapper_1n1l6_1 ._controls_1n1l6_17 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 20px;
  flex-shrink: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  